import { useState } from "react";
import UpdateTicker from "@/pages/home/components/UpdateTicker";
import SiteHeader from "@/pages/home/components/SiteHeader";
import HeroSection from "@/pages/home/components/HeroSection";
import NewReleases from "@/pages/home/components/NewReleases";
import CatalogSection from "@/pages/home/components/CatalogSection";
import FeaturedReviews from "@/pages/home/components/FeaturedReviews";
import CharacterSection from "@/pages/home/components/CharacterSection";
import WatchGuide from "@/pages/home/components/WatchGuide";
import FaqSection from "@/pages/home/components/FaqSection";
import TopicSection from "@/pages/home/components/TopicSection";
import SiteFooter from "@/pages/home/components/SiteFooter";

export default function Home() {
  const [activeCategory, setActiveCategory] = useState("全部");

  return (
    <div className="min-h-screen w-full bg-background-50">
      <UpdateTicker />
      <SiteHeader />
      <main className="w-full">
        <HeroSection onPickCategory={setActiveCategory} />
        <NewReleases />
        <CatalogSection activeCategory={activeCategory} onChangeCategory={setActiveCategory} />
        <FeaturedReviews />
        <CharacterSection />
        <WatchGuide />
        <FaqSection />
        <TopicSection onPickCategory={setActiveCategory} />
      </main>
      <SiteFooter onPickCategory={setActiveCategory} />
    </div>
  );
}